import { Typography } from '@/components/ui/typography'
import { formatCurrency } from '@/lib/utils'
import type { RefundDestinationLine } from './refund-destinations'

/** The refund destination lines a refund or an order change will send money to. */
export function RefundDestinationList({ lines }: { lines: RefundDestinationLine[] }) {
  return lines.map((line) => {
    const tone = line.tone === 'warning' ? 'warning' : 'muted'

    return (
      <div key={line.key} className="flex items-center justify-between gap-2">
        <Typography variant="supporting" tone={tone}>
          {line.label}
        </Typography>
        <Typography variant="labelStrong" tone={tone}>
          {formatCurrency(line.amount)}
        </Typography>
      </div>
    )
  })
}
